<script>
export let posicao;
export let id_botao;
export let isOpen=true;
export let botao;
export let link;
export let tipoLink;
export let corLetraBotao;
export let corBotao;
export let sombraBotao1;
export let sombraBotao2;
export let sombraBotao3;
export let sombraBotao4;
export let corSombraBotao;
export let espacamentoBotaoInferior;
export let espacamentoBotaoSuperior;
export let tipoUsuario;
import Avancado from "./detalheAvancado.svelte";

import {createEventDispatcher } from 'svelte';
import {onMount} from "svelte";
const dispatch = createEventDispatcher();



import {Button,  
  ButtonGroup,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader, Collapse, Card, Jumbotron} from "sveltestrap";


function Cancelar() {
    console.log("Cancelar");
    dispatch("Cancelar");
}
function Salvar(e) {
    e.preventDefault();

    let btn = {id:Math.random(), itemIdBotao:id_botao, itemLink:link, itemBotao:botao,
		itemCorBotao:corBotao, itemCorLetraBotao:corLetraBotao}
    dispatch("Edicao", btn);
    console.log("btn"+btn.itemBotao)
}
function Apagar(e) {
    e.preventDefault();

    
    dispatch("Apagar");
   console.log("Apagar");
}
function Sobe(e) {
    e.preventDefault();

    
    dispatch("Sobe");
   console.log("Sobe");
}function Desce(e) {
    e.preventDefault();

    
    dispatch("Desce");
   console.log("Desce");
}
</script>

<Collapse {isOpen}  > 
                   
<Jumbotron class="border border-dark" >


<div class="container">


<div class="col-12  mb-2 text-center">
        <div class="row text-center">
           
		    
            <h2 class="col-12">Editar este botão</h2>
          </div>
        </div>
		</div>
        <div class="row text-center">
          <div class="col-lg-3 col-12 text-center">
         
              <label for="NomeBotao">Nome do botão</label>
				<input class="form-control" type="text" id="NomeBotao" bind:value={botao} />
	 			<br>
         
            
          </div>
          <div class="col-lg-3 col-12">
         
            <label for="link">Inserir {tipoLink}</label>
				<input class="form-control"  type="text" id="link" bind:value={link} /> 
				
          </div>
		 
		  <br>
		  <div class="col-lg-2 col-12"> 
		 <label>Tipo de botão</label>
          
            <select class="form-control" bind:value={tipoLink} >
               
				<option  value="link"   > Link</option> 
				<option  value="telefone" >Telefone</option> 
				<option  value="whatsapp" >Whatsapp </option> 
				<option  value="email">email</option> 
				<option  value="insta">instagram</option> 
				<option  value="maps">Maps</option> 
				<option  value="uber">Uber</option> 
		  </select>
		  <br>
		  </div>
           <div class="col-lg-2 col-12"> 
		   <label class=""  for="corLetraBotao">Cor da letra</label>
	           <input class="form-control"  type="color" id="corLetraBotao"   bind:value={corLetraBotao} />
			 </div>
			  <div class="col-lg-2 col-12"> 
             	<label class=""  for="corBotao">Cor do botão</label>
	            <input  class="form-control"  type="color" id="corBotao"  bind:value={corBotao} /><p></p>
  </div>
		   <Card class="col-12 mt-2 mb-2" >
				{#if tipoLink=="link"}
				Insira um link acima. Caso não começe com http:// ou https:// será acrescentado o prefixo http://
				{:else if tipoLink=="telefone"}
				Insira um telefone acima com ddd (apenas número ex. 0819999911111)

				{:else if tipoLink=="whatsapp"}
				Insira um telefone acima com ddd (apenas número ex. 0819999911111), se preferir colcocar um link para whatsapp escolha a opção link
				{:else if tipoLink=="email"}
				Insira um email acima ex seu_nome@operadora.com.br
				{:else if tipoLink=="insta"}
				Insira um Instagram no formato @+nome ex. @linkagenda.  Se preferir colocar um link para Instagram, escolha a opção link.
				{:else if tipoLink=="maps"}
				Insira as coordenadas decimais no formato latitude, longitude . Ex. -7.219891,-35.8661268.  Se preferir colocar um link para o google maps, escolha a opção link.
				{:else if tipoLink=="uber"}
				Insira as coordenadas decimais no formato latitude, longitude . Ex. -7.219891,-35.8661268.  Se preferir colocar um link para o Uber, escolha a opção link.
			
				{/if}
				</Card>
      <br>
      <br>
	  
        <div class="container col-12 text-center">
          <div class="row col-12">
            
				<ul>
				
				
				
				</ul>
				<div class="col-12 flex-nowrap">
					
						<button class="col-lg-2   col-12 m-2 btn btn-success "on:click|preventDefault={Salvar} >Salvar</button>	
						<button class="col-lg-2  col-12 m-2 btn btn-warning " on:click|preventDefault={Cancelar} >Cancelar</button>
						<button class="col-lg-2  col-12 m-2 btn btn-danger  " on:click|preventDefault={Apagar} >Apagar botão</button>
			
					
				</div>

    
   


</div>
          
    <div class="row text-center  flex-nowrap">   
    <div class="col-12">
    <button class="col-3 m-2 btn btn-secondary "on:click|preventDefault={Sobe} >Sobe</button>	
        <button class="col-3 m-2 btn btn-secondary "on:click|preventDefault={Desce} >Desce</button>	
         
    </div>
                      
         	

			
				
				            
           
          </div>
	<br>
        </div>
      </Jumbotron>
                         

</Collapse> 
<style>
.largo{
    width:80%;
}

</style>